import editorList from './editor-none';
import associateEditorsReviewType from './associateEditors-reviewType';

export default [ ...editorList, ...associateEditorsReviewType ];